'use client';

import React from 'react';
import { LOCATION } from 'src/hooks/filters/constants';
import useStrategies from 'src/hooks/strategy/useStrategies';
import { StrategyFeatureMarker } from 'src/components/Strategy/shared';

import type { DisplayOption } from 'src/components/Strategy/shared/StrategyFeatureMarker/StrategyFeatureMarker';

type StrategyCenterMarkerProps = {
  listMember: any;
  position: { lat: number; lng: number };
  metricLabel?: string;
  metricData?: Record<string, number | any>;
  displayOptions?: DisplayOption[];
  isHovered?: boolean;
  onMarkerClick?: (memberId: string) => void;
  onMouseOver?: (memberId: string) => void;
  onMouseOut?: () => void;
  onAddToList?: () => void;
};

const StrategyCenterMarker = (props: StrategyCenterMarkerProps) => {
  const { selectedProviders, setSelectedProviders, setSelectedProvider } =
    useStrategies(LOCATION.STRATEGY_CENTER);

  return (
    <StrategyFeatureMarker
      {...props}
      setSelectedProvider={setSelectedProvider}
      selectedProviders={selectedProviders}
      setSelectedProviders={setSelectedProviders}
    />
  );
};

export default StrategyCenterMarker;
